import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';

const SliderWrapper = styled.div`
  width: 103%;
  margin-left: 9px;
  position: relative;
  overflow-x: hidden;
  overflow-y: visible;
`;

const SliderList = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ScreenshootItem = styled.li`
  flex-shrink: 0;
  min-height: 153px;
  margin-right: 10px;
  > img {
    width: 161px;
  }
`;

const screenshootsImages = [
  'track-number',
  'find-crowd',
  'location-history',
  'share-location',
  'chat-private',
];

const ScreenshotSlider = ({ onScreenshootClick }) => {
  const containerRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const handleTouchStart = (e) => {
    const startX = e.touches[0].clientX;
    let deltaX = 0;

    const handleTouchMove = (e) => {
      deltaX = e.touches[0].clientX - startX;
    };

    const handleTouchEnd = () => {
      if (deltaX !== 0) {
        const sensitivity = 50;
        if (deltaX > sensitivity) {
          handleSwipe('prev');
        } else if (deltaX < -sensitivity) {
          handleSwipe('next');
        }
      }

      deltaX = 0;
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };

    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
  };

  const slides = useMemo(() => {
    if (screenshootsImages.length > 1) {
      let items = screenshootsImages.map((data, index) => (
        <ScreenshootItem key={index}>
          <img
            src={`../assets/slider/${data}.png`}
            alt={data}
            onClick={onScreenshootClick}
          />
        </ScreenshootItem>
      ));
      return [...items];
    }
  }, [onScreenshootClick]);

  const handleSwipe = useCallback(
    (mode) => {
      containerRef.current.style.transitionDuration = '400ms';
      if (mode === 'prev') {
        if (current <= 1) {
          setTranslateX(0);
          setCurrent(0);
        } else {
          setTranslateX(171 * (current - 1));
          setCurrent((prev) => --prev);
        }
      } else if (mode === 'next') {
        if (current === screenshootsImages.length - 2) {
          setCurrent(screenshootsImages.length - 2);
        } else {
          setTranslateX(171 * (current + 1));
          setCurrent((prev) => ++prev);
        }
      }
    },
    [current]
  );

  useLayoutEffect(() => {
    setTranslateX(171 * current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const transitionEnd = () => {
      if (current <= 1) {
        containerRef.current.style.transitionDuration = '0ms';
        setTranslateX(171 * current);
      }
      if (current >= screenshootsImages.length) {
        containerRef.current.style.transitionDuration = '0ms';
        setTranslateX(171 * screenshootsImages.length);
      }
    };
    document.addEventListener('transitionend', transitionEnd);
    return () => {
      document.removeEventListener('transitionend', transitionEnd);
    };
  }, [current]);

  return (
    <>
      <SliderWrapper>
        <SliderList
          ref={containerRef}
          style={{
            transform: `translate3d(${-translateX}px, 0, 0)`,
          }}
          onTouchStart={handleTouchStart}
        >
          {slides}
        </SliderList>
      </SliderWrapper>
    </>
  );
};

export default ScreenshotSlider;
